<template>
  <h1 class="notfound">404 Not Found</h1>
</template>

<script>
export default {
  setup() {},
};
</script>

